import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  ILifeInsuranceCoverageNeed,
} from "./lifeInsuranceCoverageNeed.types";

export const FETCH_LIFE_INSURANCE_COVERAGE_NEED_PROGRESS =
  "FETCH_LIFE_INSURANCE_COVERAGE_NEED_PROGRESS";
export const FETCH_LIFE_INSURANCE_COVERAGE_NEED_SUCCESS =
  "FETCH_LIFE_INSURANCE_COVERAGE_NEED_SUCCESS";
export const FETCH_LIFE_INSURANCE_COVERAGE_NEED_FAILED =
  "FETCH_LIFE_INSURANCE_COVERAGE_NEED_FAILED";

export const fetchLifeInsuranceCoverageNeedProgress = () =>
  action(FETCH_LIFE_INSURANCE_COVERAGE_NEED_PROGRESS);
export const fetchLifeInsuranceCoverageNeedSuccess = (
  data: ILifeInsuranceCoverageNeed
) => action(FETCH_LIFE_INSURANCE_COVERAGE_NEED_SUCCESS, { data });
export const fetchLifeInsuranceCoverageNeedFailed = (errorMessage: string) =>
  action(FETCH_LIFE_INSURANCE_COVERAGE_NEED_FAILED, { errorMessage });

export const fetchLifeInsuranceCoverageNeedAsync =
  (customerPolicyId: number, incrementalNumber?: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLifeInsuranceCoverageNeedProgress());
      let url = `/policy/get-life-policy-coverage-needs?customer_policy_id=${customerPolicyId}`;
      if (incrementalNumber !== undefined) {
        url += `&incremental_number=${incrementalNumber}`;
      }
      const res = await api.get(url);
      const data: ILifeInsuranceCoverageNeed[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchLifeInsuranceCoverageNeedSuccess(data[0]));
      } else {
        dispatch(
          fetchLifeInsuranceCoverageNeedFailed("Record not found")
        );
      }
    } catch (err: any) {
      dispatch(
        fetchLifeInsuranceCoverageNeedFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addLifeInsuranceCoverageNeedAsync =
  (
    coverage: ILifeInsuranceCoverageNeed,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post(`/policy/edit-life-policy-coverage-needs`, {
        ...coverage,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Coverage Need saved successfully!",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
      onCallback(false);
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_LIFE_INSURANCE_COVERAGE_NEED_STATE =
  "CLEAR_LIFE_INSURANCE_COVERAGE_NEED_STATE";
export const CLEAR_LIFE_INSURANCE_COVERAGE_NEED =
  "CLEAR_LIFE_INSURANCE_COVERAGE_NEED";

export const clearLifeInsuranceCoverageNeedState = () =>
  action(CLEAR_LIFE_INSURANCE_COVERAGE_NEED_STATE);

export const cleaLifeInsuranceCoverageNeed = () =>
  action(CLEAR_LIFE_INSURANCE_COVERAGE_NEED);

// /policy/edit-life-policy-coverage-needs
// /policy/get-life-policy-coverage-needs

/**
 * Coverage Need List Actions
 */

export const FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_PROGRESS =
  "FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_PROGRESS";
export const FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_SUCCESS =
  "FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_SUCCESS";
export const FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_FAILED =
  "FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_FAILED";

export const fetchLifeInsuranceCoverageNeedListProgress = () =>
  action(FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_PROGRESS);
export const fetchLifeInsuranceCoverageNeedListSuccess = (
  data: ILifeInsuranceCoverageNeed[]
) => action(FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_SUCCESS, { data });
export const fetchLifeInsuranceCoverageNeedListFailed = (
  errorMessage: string
) => action(FETCH_LIFE_INSURANCE_COVERAGE_NEED_LIST_FAILED, { errorMessage });

export const fetchLifeInsuranceCoverageNeedListAsync =
  (
    customerPolicyId: number,
    status?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLifeInsuranceCoverageNeedListProgress());
      let finalUrl = `/policy/get-life-policy-coverage-needs?customer_policy_id=${customerPolicyId}`;
      if (status !== undefined && status !== "-1") {
        finalUrl += `&status=${status}`;
      }
      const res = await api.get(finalUrl);
      const data: ILifeInsuranceCoverageNeed[] = res.data.data;
      dispatch(fetchLifeInsuranceCoverageNeedListSuccess(data));
    } catch (err: any) {
      dispatch(
        fetchLifeInsuranceCoverageNeedListFailed(
          "Something went wrong!"
        )
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

/**
 * Coverage Need PDF Download
 */

export const downloadLifeInsuranceCoverageNeedPDFAsync =
  (
    customerPolicyId: number,
    incrementalNumber: number,
    onCallback: () => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/policy/get-life-policy-coverage-needs-pdf?customer_policy_id=${customerPolicyId}&incremental_number=${incrementalNumber}`,
        {
          responseType: "blob",
        }
      );

      const pdfBlob = new Blob([res.data], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "coverage_needs.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(pdfUrl);
      onCallback();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/**
 * Coverage Need PDF Preview
 */

export const previewLifeInsuranceCoverageNeedPDFAsync =
  (
    customerPolicyId: number,
    incrementalNumber: number,
    onCallback: () => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const res = await api.get(
        `/policy/get-life-policy-coverage-needs-pdf?customer_policy_id=${customerPolicyId}&incremental_number=${incrementalNumber}&is_coverage_needs_preview=true`
      );

      for (const key in res.data.data) {
        const newTab = window.open("", "_blank");
        if (newTab) {
          newTab.document.write(res.data.data[key]);
          newTab.document.close();
        }
      }
      onCallback();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };
